import { useSession } from "@/utils/auth/client";

export const useAuthenticatedUserQuery = () => useSession();
